export const getNotificationColor = (type: string): string => {
  switch (type) {
    case 'success':
      return 'green';
    case 'error':
      return 'red';
    case 'warning':
      return 'orange';
    case 'info':
      return 'blue';
    case 'update':
      return 'blue';
    default:
      return 'gray';
  }
};
